import store from "@src/reducers/store";
import { getNodeManager } from "../dependency-injection-container/get-node-manager";
import {
  emptyNodeDataObject,
  updateNodeSelectionNodeData,
  updateNodeSelectionState,
  updateStructureWasSaved,
} from "@src/reducers/your-reducer";
import { getLogger } from "../dependency-injection-container/get-logger";

export const deleteNodesFromNodeset = () => {
  const logger = getLogger();
  const t0 = performance.now();
  logger.debug("t0 - start of action", t0);

  const nodeManager = getNodeManager();
  nodeManager.deleteNodesFromNodesetHandler().deleteNodesFromNodeset();

  store.dispatch(updateNodeSelectionState("none"));
  store.dispatch(updateNodeSelectionNodeData(emptyNodeDataObject));
  store.dispatch(updateStructureWasSaved(false));

  const t1 = performance.now();
  logger.debug("t1 - end of action", t1);
  logger.debug(
    `Action to delete node on new structure took ${t1 - t0} milliseconds.`,
  );
};
